import { Language } from '../types/Languages';

const ar = require(`./locales/ar.json`);
const bn = require(`./locales/bn.json`);
const en = require(`./locales/en.json`);
const es = require(`./locales/es.json`);
const ht = require(`./locales/ht.json`);
const ko = require(`./locales/ko.json`);
const ru = require(`./locales/ru.json`);
const ur = require(`./locales/ur.json`);
const zh = require(`./locales/zh.json`);

const Languages = {
  languages: [
    { name: 'en', label: 'English', full: 'english' },
    { name: 'es', label: 'Español', full: 'spanish' },
    { name: 'ru', label: 'русский', full: 'russian' },
    { name: 'zh', label: '为中文', full: 'chinese' },
    { name: 'bn', label: 'বাংলা', full: 'bengali' },
    { name: 'ko', label: '한국어', full: 'korean' },
    { name: 'ar', label: 'عربى', full: 'arabic' },
    { name: 'ur', label: 'اردو', full: 'urdu' },
    { name: 'ht', label: 'Kreyòl Ayisyen', full: 'haitian' },
  ] as Language[],
  states: [
    { name: 'Alabama', value: 'AL' },
    { name: 'Alaska', value: 'AK' },
    { name: 'Arizona', value: 'AZ' },
    { name: 'Arkansas', value: 'AR' },
    { name: 'California', value: 'CA' },
    { name: 'Colorado', value: 'CO' },
    { name: 'Connecticut', value: 'CT' },
    { name: 'Delaware', value: 'DE' },
    { name: 'Florida', value: 'FL' },
    { name: 'Georgia', value: 'GA' },
    { name: 'Hawaii', value: 'HI' },
    { name: 'Idaho', value: 'ID' },
    { name: 'Illinois', value: 'IL' },
    { name: 'Indiana', value: 'IN' },
    { name: 'Iowa', value: 'IA' },
    { name: 'Kansas', value: 'KS' },
    { name: 'Kentucky', value: 'KY' },
    { name: 'Louisiana', value: 'LA' },
    { name: 'Maine', value: 'ME' },
    { name: 'Maryland', value: 'MD' },
    { name: 'Massachusetts', value: 'MA' },
    { name: 'Michigan', value: 'MI' },
    { name: 'Minnesota', value: 'MN' },
    { name: 'Mississippi', value: 'MS' },
    { name: 'Missouri', value: 'MO' },
    { name: 'Montana', value: 'MT' },
    { name: 'Nebraska', value: 'NE' },
    { name: 'Nevada', value: 'NV' },
    { name: 'New Hampshire', value: 'NH' },
    { name: 'New Jersey', value: 'NJ' },
    { name: 'New Mexico', value: 'NM' },
    { name: 'New York', value: 'NY' },
    { name: 'North Carolina', value: 'NC' },
    { name: 'North Dakota', value: 'ND' },
    { name: 'Ohio', value: 'OH' },
    { name: 'Oklahoma', value: 'OK' },
    { name: 'Oregon', value: 'OR' },
    { name: 'Pennsylvania', value: 'PA' },
    { name: 'Rhode Island', value: 'RI' },
    { name: 'South Carolina', value: 'SC' },
    { name: 'South Dakota', value: 'SD' },
    { name: 'Tennessee', value: 'TN' },
    { name: 'Texas', value: 'TX' },
    { name: 'Utah', value: 'UT' },
    { name: 'Vermont', value: 'VT' },
    { name: 'Virginia', value: 'VA' },
    { name: 'Washington', value: 'WA' },
    { name: 'West Virginia', value: 'WV' },
    { name: 'Wisconsin', value: 'WI' },
    { name: 'Wyoming', value: 'WY' },
  ],
  translations: {
    ar,
    bn,
    en,
    es,
    ht,
    ko,
    ru,
    ur,
    zh,
  },
};

const languagesByFullName: Record<string, Language> = {};

Languages.languages.forEach((lang) => {
  languagesByFullName[lang.name] = lang;
});

export { languagesByFullName };
export default Languages;
